<kui-modal #modal size="fill" [title]="data.title" [actions]="modalActions" (onClose)="detachModal()">
    <iframe width="100%" height="100%" frameBorder="0" [src]="url"></iframe>
</kui-modal>
